module.exports = __webpack_public_path__ + "img/logo.fc485cb3.png";